import { Duration } from 'dayjs/plugin/duration.js';
import { DataModelBuilder, isSameData, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { FlexibleServiceDuration } from '../../models/serializable/flexible-service-duration.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class FlexibleServiceDurationComponent extends Component {
  static readonly TYPE_ID: string = '6108cc546dd94060a86e99621fd32d9b';

  private constructor(
    public readonly flexibleDuration: FlexibleServiceDuration,
  ) {
    super();
  }

  get duration(): Duration {
    return this.flexibleDuration.totalDuration;
  }

  get $typeId(): string {
    return FlexibleServiceDurationComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return false;
  }

  static create(flexibleDuration: FlexibleServiceDuration): FlexibleServiceDurationComponent {
    return new FlexibleServiceDurationComponent(flexibleDuration);
  }

  static fromMap(context: SerializationContext, map: SerializedData): FlexibleServiceDurationComponent {
    return new FlexibleServiceDurationComponent(
        context.fromData<FlexibleServiceDuration>(MapUtils.get<SerializedData>(map, 'flexibleDuration')),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'flexibleDuration': context.toData(this.flexibleDuration),
    };
  }

  clone(): this {
    return new FlexibleServiceDurationComponent(this.flexibleDuration.clone()) as this;
  }

  isSame(other: FlexibleServiceDurationComponent): boolean {
    if(this === other) {
      return true;
    }

    return isSameData(other.flexibleDuration, this.flexibleDuration) &&
        other.$removable === this.$removable;
  }
}

export class FlexibleServiceDurationComponentBuilder extends DataModelBuilder<FlexibleServiceDurationComponent> {
  build(context: SerializationContext, map: SerializedData): FlexibleServiceDurationComponent {
    return FlexibleServiceDurationComponent.fromMap(context, map);
  }
}
